module.exports = __webpack_public_path__ + "static/img/zc.6bb61da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zc.png
// module id = jHc7
// module chunks = 1